/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetDetailComponentResponseDto } from './AssetDetailComponentResponseDto';
import {
    AssetDetailComponentResponseDtoFromJSON,
    AssetDetailComponentResponseDtoFromJSONTyped,
    AssetDetailComponentResponseDtoToJSON,
    AssetDetailComponentResponseDtoToJSONTyped,
} from './AssetDetailComponentResponseDto';
import type { ConnectivityStatus } from './ConnectivityStatus';
import {
    ConnectivityStatusFromJSON,
    ConnectivityStatusFromJSONTyped,
    ConnectivityStatusToJSON,
    ConnectivityStatusToJSONTyped,
} from './ConnectivityStatus';
import type { AssetDetailZoneResponseDto } from './AssetDetailZoneResponseDto';
import {
    AssetDetailZoneResponseDtoFromJSON,
    AssetDetailZoneResponseDtoFromJSONTyped,
    AssetDetailZoneResponseDtoToJSON,
    AssetDetailZoneResponseDtoToJSONTyped,
} from './AssetDetailZoneResponseDto';
import type { AssetDetailSiteResponseDto } from './AssetDetailSiteResponseDto';
import {
    AssetDetailSiteResponseDtoFromJSON,
    AssetDetailSiteResponseDtoFromJSONTyped,
    AssetDetailSiteResponseDtoToJSON,
    AssetDetailSiteResponseDtoToJSONTyped,
} from './AssetDetailSiteResponseDto';
import type { AssetDetailLookupResponseDto } from './AssetDetailLookupResponseDto';
import {
    AssetDetailLookupResponseDtoFromJSON,
    AssetDetailLookupResponseDtoFromJSONTyped,
    AssetDetailLookupResponseDtoToJSON,
    AssetDetailLookupResponseDtoToJSONTyped,
} from './AssetDetailLookupResponseDto';
import type { EvseType } from './EvseType';
import {
    EvseTypeFromJSON,
    EvseTypeFromJSONTyped,
    EvseTypeToJSON,
    EvseTypeToJSONTyped,
} from './EvseType';

/**
 * 
 * @export
 * @interface GetAssetDetailsResponseDto
 */
export interface GetAssetDetailsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetAssetDetailsResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetAssetDetailsResponseDto
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetAssetDetailsResponseDto
     */
    assetName: string;
    /**
     * 
     * @type {string}
     * @memberof GetAssetDetailsResponseDto
     */
    serialNumber: string;
    /**
     * 
     * @type {EvseType}
     * @memberof GetAssetDetailsResponseDto
     */
    standard: EvseType | null;
    /**
     * Organization business identifier (e.g. CH-001)
     * @type {string}
     * @memberof GetAssetDetailsResponseDto
     */
    tenantAssetId: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAssetDetailsResponseDto
     */
    manufacturer: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAssetDetailsResponseDto
     */
    manufacturerId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetAssetDetailsResponseDto
     */
    installedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetAssetDetailsResponseDto
     */
    commissionedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetAssetDetailsResponseDto
     */
    decommissionedAt: Date | null;
    /**
     * 
     * @type {number}
     * @memberof GetAssetDetailsResponseDto
     */
    expectedDailyEarning: number;
    /**
     * 
     * @type {string}
     * @memberof GetAssetDetailsResponseDto
     */
    landlordOrganizationId: string | null;
    /**
     * 
     * @type {AssetDetailLookupResponseDto}
     * @memberof GetAssetDetailsResponseDto
     */
    assetModel: AssetDetailLookupResponseDto | null;
    /**
     * 
     * @type {AssetDetailLookupResponseDto}
     * @memberof GetAssetDetailsResponseDto
     */
    assetType: AssetDetailLookupResponseDto;
    /**
     * 
     * @type {AssetDetailLookupResponseDto}
     * @memberof GetAssetDetailsResponseDto
     */
    parentAsset: AssetDetailLookupResponseDto | null;
    /**
     * 
     * @type {AssetDetailSiteResponseDto}
     * @memberof GetAssetDetailsResponseDto
     */
    site: AssetDetailSiteResponseDto;
    /**
     * 
     * @type {AssetDetailZoneResponseDto}
     * @memberof GetAssetDetailsResponseDto
     */
    zone: AssetDetailZoneResponseDto | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetAssetDetailsResponseDto
     */
    rawData: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof GetAssetDetailsResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetAssetDetailsResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {Array<AssetDetailComponentResponseDto>}
     * @memberof GetAssetDetailsResponseDto
     */
    components: Array<AssetDetailComponentResponseDto>;
    /**
     * 
     * @type {boolean}
     * @memberof GetAssetDetailsResponseDto
     */
    chargerAuthenticationConfigured: boolean;
    /**
     * Last frame received from the charger (any channel). Live value from Redis, else the archived value.
     * @type {Date}
     * @memberof GetAssetDetailsResponseDto
     */
    lastSeenAt: Date | null;
    /**
     * Firmware as last reported by the charger (OCPP BootNotification or AnyOS), read only.
     * @type {string}
     * @memberof GetAssetDetailsResponseDto
     */
    firmwareVersion: string | null;
    /**
     * ONLINE / OFFLINE for monitored chargers; UNKNOWN when the platform cannot measure right now; null when the asset is not monitored.
     * @type {ConnectivityStatus}
     * @memberof GetAssetDetailsResponseDto
     */
    connectivityStatus: ConnectivityStatus | null;
    /**
     * Whether the asset organization has External CSMS proxy enabled
     * @type {boolean}
     * @memberof GetAssetDetailsResponseDto
     */
    organizationExternalCsmsEnabled: boolean;
    /**
     * Whether the asset organization requires charger HTTP Basic Authentication (only when External CSMS proxy is enabled)
     * @type {boolean}
     * @memberof GetAssetDetailsResponseDto
     */
    organizationChargerAuthenticationEnabled: boolean;
}



/**
 * Check if a given object implements the GetAssetDetailsResponseDto interface.
 */
export function instanceOfGetAssetDetailsResponseDto(value: object): value is GetAssetDetailsResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('assetName' in value) || value['assetName'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('standard' in value) || value['standard'] === undefined) return false;
    if (!('tenantAssetId' in value) || value['tenantAssetId'] === undefined) return false;
    if (!('manufacturer' in value) || value['manufacturer'] === undefined) return false;
    if (!('manufacturerId' in value) || value['manufacturerId'] === undefined) return false;
    if (!('installedAt' in value) || value['installedAt'] === undefined) return false;
    if (!('commissionedAt' in value) || value['commissionedAt'] === undefined) return false;
    if (!('decommissionedAt' in value) || value['decommissionedAt'] === undefined) return false;
    if (!('expectedDailyEarning' in value) || value['expectedDailyEarning'] === undefined) return false;
    if (!('landlordOrganizationId' in value) || value['landlordOrganizationId'] === undefined) return false;
    if (!('assetModel' in value) || value['assetModel'] === undefined) return false;
    if (!('assetType' in value) || value['assetType'] === undefined) return false;
    if (!('parentAsset' in value) || value['parentAsset'] === undefined) return false;
    if (!('site' in value) || value['site'] === undefined) return false;
    if (!('zone' in value) || value['zone'] === undefined) return false;
    if (!('rawData' in value) || value['rawData'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('components' in value) || value['components'] === undefined) return false;
    if (!('chargerAuthenticationConfigured' in value) || value['chargerAuthenticationConfigured'] === undefined) return false;
    if (!('lastSeenAt' in value) || value['lastSeenAt'] === undefined) return false;
    if (!('firmwareVersion' in value) || value['firmwareVersion'] === undefined) return false;
    if (!('connectivityStatus' in value) || value['connectivityStatus'] === undefined) return false;
    if (!('organizationExternalCsmsEnabled' in value) || value['organizationExternalCsmsEnabled'] === undefined) return false;
    if (!('organizationChargerAuthenticationEnabled' in value) || value['organizationChargerAuthenticationEnabled'] === undefined) return false;
    return true;
}

export function GetAssetDetailsResponseDtoFromJSON(json: any): GetAssetDetailsResponseDto {
    return GetAssetDetailsResponseDtoFromJSONTyped(json, false);
}

export function GetAssetDetailsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAssetDetailsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'assetName': json['assetName'],
        'serialNumber': json['serialNumber'],
        'standard': EvseTypeFromJSON(json['standard']),
        'tenantAssetId': json['tenantAssetId'],
        'manufacturer': json['manufacturer'],
        'manufacturerId': json['manufacturerId'],
        'installedAt': (json['installedAt'] == null ? null : new Date(json['installedAt'])),
        'commissionedAt': (json['commissionedAt'] == null ? null : new Date(json['commissionedAt'])),
        'decommissionedAt': (json['decommissionedAt'] == null ? null : new Date(json['decommissionedAt'])),
        'expectedDailyEarning': json['expectedDailyEarning'],
        'landlordOrganizationId': json['landlordOrganizationId'],
        'assetModel': AssetDetailLookupResponseDtoFromJSON(json['assetModel']),
        'assetType': AssetDetailLookupResponseDtoFromJSON(json['assetType']),
        'parentAsset': AssetDetailLookupResponseDtoFromJSON(json['parentAsset']),
        'site': AssetDetailSiteResponseDtoFromJSON(json['site']),
        'zone': AssetDetailZoneResponseDtoFromJSON(json['zone']),
        'rawData': json['rawData'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'components': ((json['components'] as Array<any>).map(AssetDetailComponentResponseDtoFromJSON)),
        'chargerAuthenticationConfigured': json['chargerAuthenticationConfigured'],
        'lastSeenAt': (json['lastSeenAt'] == null ? null : new Date(json['lastSeenAt'])),
        'firmwareVersion': json['firmwareVersion'],
        'connectivityStatus': ConnectivityStatusFromJSON(json['connectivityStatus']),
        'organizationExternalCsmsEnabled': json['organizationExternalCsmsEnabled'],
        'organizationChargerAuthenticationEnabled': json['organizationChargerAuthenticationEnabled'],
    };
}

export function GetAssetDetailsResponseDtoToJSON(json: any): GetAssetDetailsResponseDto {
    return GetAssetDetailsResponseDtoToJSONTyped(json, false);
}

export function GetAssetDetailsResponseDtoToJSONTyped(value?: GetAssetDetailsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'assetName': value['assetName'],
        'serialNumber': value['serialNumber'],
        'standard': EvseTypeToJSON(value['standard']),
        'tenantAssetId': value['tenantAssetId'],
        'manufacturer': value['manufacturer'],
        'manufacturerId': value['manufacturerId'],
        'installedAt': value['installedAt'] == null ? value['installedAt'] : value['installedAt'].toISOString(),
        'commissionedAt': value['commissionedAt'] == null ? value['commissionedAt'] : value['commissionedAt'].toISOString(),
        'decommissionedAt': value['decommissionedAt'] == null ? value['decommissionedAt'] : value['decommissionedAt'].toISOString(),
        'expectedDailyEarning': value['expectedDailyEarning'],
        'landlordOrganizationId': value['landlordOrganizationId'],
        'assetModel': AssetDetailLookupResponseDtoToJSON(value['assetModel']),
        'assetType': AssetDetailLookupResponseDtoToJSON(value['assetType']),
        'parentAsset': AssetDetailLookupResponseDtoToJSON(value['parentAsset']),
        'site': AssetDetailSiteResponseDtoToJSON(value['site']),
        'zone': AssetDetailZoneResponseDtoToJSON(value['zone']),
        'rawData': value['rawData'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'components': ((value['components'] as Array<any>).map(AssetDetailComponentResponseDtoToJSON)),
        'chargerAuthenticationConfigured': value['chargerAuthenticationConfigured'],
        'lastSeenAt': value['lastSeenAt'] == null ? value['lastSeenAt'] : value['lastSeenAt'].toISOString(),
        'firmwareVersion': value['firmwareVersion'],
        'connectivityStatus': ConnectivityStatusToJSON(value['connectivityStatus']),
        'organizationExternalCsmsEnabled': value['organizationExternalCsmsEnabled'],
        'organizationChargerAuthenticationEnabled': value['organizationChargerAuthenticationEnabled'],
    };
}

